import React from "react";
import "font-awesome/css/font-awesome.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faFileExcel, faCheckSquare, faTimesSquare } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { CSVLink } from "react-csv";
import { logsColumnData, } from "content/static";

const dateFromate = (date) => moment(date).format("YYYY-MM-DD h:mm:A")
const fileName = (logFrom) => logFrom + "_" + dateFromate()
const getSortIcon = (sortable, sortField, accessor, order) => {
    if (!sortable) return "";
    if (sortField !== accessor) return "default";
    return order === "asc" ? "up" : order === "desc" ? "down" : "default";
}


const TableComponent = ({ sortField, order, handleSortingChange, rowData, clickView }) => {
    return <div className="row mt-3">
        <div className="smartTable-tableContainer">
            <table className="smartTable-table table table-striped border">
                <thead className="smartTable-thead">
                    <tr>
                        {logsColumnData.map(({ label, accessor, sortable }) => {
                            const cl = getSortIcon(sortable, sortField, accessor, order)
                            return (
                                <th
                                    key={accessor}
                                    onClick={() => sortable && handleSortingChange(accessor)}
                                    className={`${cl} smartTable-pointer`}
                                >
                                    {label}
                                </th>
                            );
                        })}
                    </tr>
                </thead>

                <tbody>
                    {rowData && rowData?.map((item) => {
                        const clickCallback = (e) => clickView(item.logText, item.logMessage, item.logFrom, item.logType);
                        return (
                            <tr key={item._id}>
                                <td>{item.software || '-'}</td>
                                <td>{dateFromate(item.createdAt)}</td>
                                <td>{item.logFrom}</td>
                                <td>{`${item.validationChecked}`}</td>
                                <td>{StatusIcon[item.logType]}</td>
                                <td className="action">
                                    <FontAwesomeIcon
                                        icon={faEye}
                                        className="text-primary cursor-pointer"
                                        onClick={clickCallback}
                                        title="View"
                                    />
                                    {item?.logText &&
                                        <CSVLink
                                            data={item?.logText || []}
                                            filename={fileName(item.logFrom)}
                                            className="btn download-button"
                                            target="_blank"
                                        >
                                            {<FontAwesomeIcon icon={faFileExcel} />}
                                        </CSVLink>
                                    }
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {(!rowData || rowData.length === 0) && (
                <div className="col-12 text-center p-4 text-danger">
                    <h4>No Data Found</h4>
                </div>
            )}
        </div>
    </div>
}

const StatusIcon = {
    success: (
        <span className="text-success cursor-pointer">
            <FontAwesomeIcon icon={faCheckSquare} className="text-success mr-1" />Success
        </span>
    ),
    failure: (
        <span
            className="text-danger cursor-pointer"
            // data-tip={`${item.logMessage["message"]}`}
            data-for="toolTipRefss"
        >
            <FontAwesomeIcon icon={faTimesSquare} className="text-danger mr-1" />
            Failure
        </span>
    ),
};
export default TableComponent